import accounts from './accounts';

export default {
  accounts: accounts,
};
